$(document).ready(function(){
  // 「薬学生JOBマッチスタート」ボタン押下時に、ページ遷移せずページトップにスクロールされるのを防ぐ。
  // (ページトップボタンの中に入っているため発生する)
  $('.gotop a').off("click");

  // gotopの代わりに、go_top_wrapがクリックされた時にスクロールするようにする。
  $('.go_top_wrap a').click(function(){
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    // ページのトップへ 500 のスピードでスクロールする
    return false;
  });
});